var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Headersys'),_vm._m(0),_c('Back')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',[_c('canvas',{attrs:{"id":"qrCode"}}),_c('div',{staticClass:"qr-tips"},[_vm._v("手机扫描二维码进行申报")])])])
}]

export { render, staticRenderFns }